import {
    getBrandAccountTypeImage,
    getBrandAssetUrl,
    getBrandCloseIcon,
    getBrandEmptyListImage,
    getBrandFillerImage,
    getBrandKey,
} from 'helpers/brandIdentity';
import { useSelector } from 'react-redux';
import { selectCompanyName, selectImagePath } from 'reducers/ui';

export const useBrandIdentity = () => {
    const imagesPath = useSelector(selectImagePath);
    const companyName = useSelector(selectCompanyName);
    const brandKey = getBrandKey(imagesPath, companyName);

    return {
        brandKey,
        imagesPath,
        companyName,
        fillerImage: getBrandFillerImage(imagesPath, companyName),
        emptyListImage: getBrandEmptyListImage(imagesPath, companyName),
        accountTypeImage: getBrandAccountTypeImage(imagesPath, companyName),
        closeIcon: getBrandCloseIcon(imagesPath, companyName),
        asset: (fileName: string) => getBrandAssetUrl(imagesPath, companyName, fileName),
    };
};
